<div
  class="splash"
  role="button"
  [class.show]="show$()"
  [attr.aria-label]="'Common.Close' | translate"
  (click)="show$.set(false)"
>
  <div class="circle-bg"></div>
  <div class="center-section splash-1">
    <ion-img src="assets/icon/logo-full.svg" alt="Youtopia"></ion-img>
    <div class="title">
      {{ 'Splash.Title_1' | translate }}
    </div>
    <div class="title">
      {{ 'Splash.Title_2' | translate }}
    </div>
  </div>
</div>
